export const FETCH_LEADERBOARD_CONTENT = 'FETCH_LEADERBOARD_CONTENT'
export const FETCH_LEADERBOARD_CONTENT_SUCCESS =
  'FETCH_LEADERBOARD_CONTENT_SUCCESS'
export const FETCH_LEADERBOARD_CONTENT_FAILURE =
  'FETCH_LEADERBOARD_CONTENT_FAILURE'
export const FETCH_LEADERBOARD_CONTENT_CANCEL =
  'FETCH_LEADERBOARD_CONTENT_CANCEL'
